import Socials from "../components/Socials";
import Title from "../components/Title";
import Subtitle from "../components/Subtitle";
import Paragraph from "../components/Paragraph";

export default function About() {
  return (
    <>
      <section id="about" className="about-section">
        <div className="about-container">
          <div className="about-image-wrapper">
            <img
              className="about-image"
              src="/images/headshot.png"
              alt="Lauren Abramsky"
              fetchpriority="high"
              width="250"
              height="278"
              sizes="(max-width: 568px) 200px, (max-width: 768px) 300px, 250px"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>

          <div className="about-content">
            <Title headingLevel={2} size="L">
              About <i>Me</i>
            </Title>

            <Subtitle>
              MISSION-DRIVEN | INCLUSION | CONNECTION
            </Subtitle>

            <Paragraph>
              <p>
                I'm driven by helping people feel valued, heard, and connected.
              </p>
              <p>
                I build inclusive, accessible digital tools that help make society better. My past work includes software development at Adobe, Deloitte Digital, and worker-tech startups in London.
              </p>
              <p>
                When I'm not coding, I love drawing, throwing pottery, and planning socials for my local grassroots football team, Lush Lyfe FC.
              </p>
            </Paragraph>

            <div className="about-socials">
              <Socials />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}


